import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {AuthenticationService} from '../services/authentication.service';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    if (this.authenticationService.isLoggedIn()) {
      const currentUser = this.authenticationService.currentUserValue;

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
          'http-x-access-key': `${environment.key.http_access}`
        }
      });
    }
    return next.handle(request);
  }
}
